import React from 'react'
import PropTypes from 'prop-types'
import { compact } from 'lodash'
import { Box, Typography } from '@material-ui/core'

import useStyles from './styles'

// Documentos gerados a partir do mesmo modelo costumam ter títulos idênticos, então o título sozinho
// não identifica a opção. O código, o identificador e a versão vigente são o que permitem ao usuário
// saber qual documento está anexando como evidência.
const DocumentOption = ({ option }) => {
  const classes = useStyles()

  const details = compact([
    option?.code,
    `ID ${option?.id}`,
    option?.version && `v${option.version}.${option.review || 0}`,
  ])

  return (
    <Box className={classes.option}>
      <Typography className={classes.title}>{option?.title}</Typography>
      <Typography variant="caption" color="secondary">
        {details.join(' · ')}
      </Typography>
    </Box>
  )
}

DocumentOption.propTypes = {
  option: PropTypes.object.isRequired,
}

export default DocumentOption
